import { render, staticRenderFns } from "./riseDetail.vue?vue&type=template&id=d8db10d6&scoped=true"
import script from "./riseDetail.vue?vue&type=script&lang=js"
export * from "./riseDetail.vue?vue&type=script&lang=js"
import style0 from "./riseDetail.vue?vue&type=style&index=0&id=d8db10d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8db10d6",
  null
  
)

export default component.exports